/* Copyright Information: Created by BuyGroup */
const Roles = {
  ADMIN: "ADMIN",
  SUB_ADMIN: "SUB_ADMIN",
  SUPPLIER: "SUPPLIER",
};
export default Roles;
/* Copyright Information: Created by BuyGroup */
